import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/vendors/settings/notifications/Page";

export const PATH = "/vendors/settings/notifications";

function Home() {
	return (
		<>
			<NskHead title="通知設定" />
			<Component />
		</>
	);
}

export default Home;
